import axios from "axios";
import { base_url, config } from "../../utils/axiosConfig";

const getProducts = async (data) => {

  const queryParams = [];

  if (data?.brand) {
    queryParams.push(`brand=${encodeURIComponent(data.brand)}`);
  }

  if (data?.tag) {
    queryParams.push(`tags=${encodeURIComponent(data.tag)}`);
  }

  // 🔹 OLD CATEGORY (TITLE) – OPTIONAL
  if (data?.category) {
    queryParams.push(`category=${encodeURIComponent(data.category)}`);
  }

  // ✅ NEW CATEGORY SLUG FILTER
  if (data?.category_slug) {
    queryParams.push(
      `category_slug=${encodeURIComponent(data.category_slug)}`
    );
  }

  if (data?.minPrice) {
    queryParams.push(`price[gte]=${data.minPrice}`);
  }

  if (data?.maxPrice) {
    queryParams.push(`price[lte]=${data.maxPrice}`);
  }
  // if (!data?.category &&  !data?.category_slug) {
  //   queryParams.push(`category=all`);
  // }
  if (data?.sort) {
    queryParams.push(`sort=${data.sort}`);
  }

  const queryString = queryParams.join("&");

  const response = await axios.get(
    `${base_url}product${queryString ? `?${queryString}` : ""}`
  );


  return response.data;
};



const getSingleProduct = async (id) => {
  const response = await axios.get(`${base_url}product/${id}`);
  if (response.data) {
    return response.data;
  }
};

const getCategory = async (id) => {
  const response = await axios.get(`${base_url}product/category`);
  if (response.data) {
    return response.data;
  }
};

const addToWishlist = async (prodId) => {
  const response = await axios.put(
    `${base_url}product/Wishlist`,
    { prodId },
    config
  );
  if (response.data) {
    return response.data;
  }
};

const rateProduct = async (data) => {
  const response = await axios.put(`${base_url}product/rating`, data, config);
  if (response.data) {
    return response.data;
  }
};

const getHomePageSlider = async () => {
  const response = await axios.get(`${base_url}sliders`);
  if (response.data) {
    return response.data;
  }
};
const getHomePagePromoBanner = async () => {
  const response = await axios.get(`${base_url}banners`);
  if (response.data) {
    return response.data;
  }
};

const getProductsForStore = async (data) => {

  const queryParams = [];

  if (data?.brand) {
    queryParams.push(`brand=${encodeURIComponent(data.brand)}`);
  }

  if (data?.tag) {
    queryParams.push(`tags=${encodeURIComponent(data.tag)}`);
  }

  // 🔹 OLD CATEGORY (TITLE) – OPTIONAL
  if (data?.category) {
    queryParams.push(`category=${encodeURIComponent(data.category)}`);
  }

  // ✅ NEW CATEGORY SLUG FILTER
  if (data?.category_slug) {
    queryParams.push(
      `category_slug=${encodeURIComponent(data.category_slug)}`
    );
  }

  if (data?.minPrice) {
    queryParams.push(`price[gte]=${data.minPrice}`);
  }

  if (data?.maxPrice) {
    queryParams.push(`price[lte]=${data.maxPrice}`);
  }
  // if (!data?.category &&  !data?.category_slug) {
  //   queryParams.push(`category=all`);
  // }
  if (data?.sort) {
    queryParams.push(`sort=${data.sort}`);
  }

  const queryString = queryParams.join("&");

  const response = await axios.get(
    `${base_url}product${queryString ? `?${queryString}` : ""}`
  );


  return response.data;
};

export const productSevice = {
  getProducts,
  addToWishlist,
  getSingleProduct,
  rateProduct,
  getCategory,
  getHomePageSlider,
  getHomePagePromoBanner,
  getProductsForStore
};
